import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { cartApi, type AddToCartPayload, type UpdateQtyPayload, type MergeCartPayload, type ServerCart } from '../api/cart.api'
import { qk } from '@/lib/api/queryKeys'
import { useApiAuth } from '@/modules/auth-api'

export function useServerCart() {
  const isAuthed = useApiAuth((s) => s.isAuthed)
  return useQuery({
    queryKey: qk.cart.me,
    queryFn: () => cartApi.get(),
    enabled: isAuthed,
    staleTime: 30_000,
  })
}

export function useAddToServerCart() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (p: AddToCartPayload) => cartApi.add(p),
    onSuccess: (data) => qc.setQueryData<ServerCart>(qk.cart.me, data),
  })
}

export function useUpdateServerCartQty() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (p: UpdateQtyPayload) => cartApi.updateQty(p),
    onSuccess: (data) => qc.setQueryData<ServerCart>(qk.cart.me, data),
  })
}

export function useRemoveServerCartItem() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (itemId: string) => cartApi.remove(itemId),
    onSuccess: (data) => qc.setQueryData<ServerCart>(qk.cart.me, data),
  })
}

export function useClearServerCart() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => cartApi.clear(),
    onSuccess: (data) => qc.setQueryData<ServerCart>(qk.cart.me, data),
  })
}

export function useMergeServerCart() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (p: MergeCartPayload) => cartApi.merge(p),
    onSuccess: (data) => qc.setQueryData<ServerCart>(qk.cart.me, data),
  })
}
